module.exports = __webpack_public_path__ + "img/0S6A9521.fa734293.jpg";